import { Injectable } from '@angular/core';
// import { Buffer } from 'buffer';
import * as buffer from 'buffer';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface AppConfig {
  baseAuthUrl: string;
  baseAssetUrl: string;
  baseConfigUrl: string;
  baseReportUrl: string;
  baseNotificationUrl: string;
  baseGeoUrl: string;
  baseComponentUrl: string;
  baseDataUrl: string;
  baseSearchUrl: string;
  baseKnowledgeUrl: string;
  blobUrl: string;
  standardPasswordPolicy: string;
  encryptionKey: string;
  matomoSiteId: string;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private config: AppConfig;

  private $config: Observable<AppConfig> = this.http.get<AppConfig>('/assets/config/config.json');

  constructor(private http: HttpClient) {}

  init() {
    //Added to load config.json
    this.loadConfig();
    if (this.config) {
      const encryptedKey = this.getConfig().encryptionKey;
      // Ref: https://medium.com/geekculture/how-to-encrypt-webstorage-in-angular-97094a0c5809
      // overriding the global storage functions here
      Storage.prototype['_setItem'] = Storage.prototype.setItem;
      Storage.prototype['_getItem'] = Storage.prototype.getItem;
      Storage.prototype['_removeItem'] = Storage.prototype.removeItem;

      Storage.prototype.setItem = function (key, value) {
        if (key) {
          const encodedKey = Buffer.from(key).toString('base64');
        }
      };

      Storage.prototype.getItem = function (key) {
        if (key) {
          const encodedKey = Buffer.from(key).toString('base64');
          const value = this._getItem(encodedKey);
          if (value) {
            return value;
          } else {
            return null;
          }
        }
      };

      Storage.prototype.removeItem = function (key) {
        if (key) {
          const encodedKey = Buffer.from(key).toString('base64');
          if (encodedKey) this._removeItem(encodedKey);
        }
      };
    }
  }

  async loadConfig() {
    this.config = await this.$config.toPromise();
    return this.config;
  }

  getOberservableConfig(): Observable<AppConfig> {
    return this.$config;
  }

  getConfig(): AppConfig {
    return this.config;
  }
}
